import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { MaterialModule } from '@app/material.module';

@Component({
  selector: 'app-custom-snack-bar',
  imports: [MaterialModule],
  templateUrl: './custom-snack-bar.component.html',
  styleUrl: './custom-snack-bar.component.scss'
})
export class CustomSnackBarComponent {

  constructor(
    public snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  public close(): void {
    this.snackBar._openedSnackBarRef!.dismiss();
  }
}
